import {
  WSActions,
  WSDivider,
  WSFlexBox,
  WSGrid,
  WSList,
  WSSectionToolbar
} from "@wingspanhq/fe-component-library";
import type { cardApiSpec } from "@wingspanhq/wingspan-api-types";
import { useQueryCard } from "../../../../query/cards/queries/useQueryCard";
import { WSQueries } from "../../../../query/WSQuery";
import { routeHelpersEmbeddedManageWalletCardsCard } from "../../paths";
import { CardBalance } from "../../../Wallet/routes/RouteCardDetails/CardBalance";
import { CardBillingInfo } from "../../../Wallet/routes/RouteCardDetails/CardBillingInfo";
import { useActionButtons } from "../../../Wallet/routes/RouteCardDetails/useActionButtons";
import { WalletCardType } from "../../../Wallet/types";
import { EmbeddedWalletCardSlot } from "./EmbeddedWalletCardSlot";
import { WALLET_CARD_TITLES } from "./EmbeddedWalletCardsLanding";
import { sendCardUpdatedToParent } from "./walletCardEvents";
import { WalletCardSkeleton } from "./WalletCardSkeleton";

type Props = {
  onBack: () => void;
};

export const EmbeddedWalletCardDetails: React.FC<Props> = ({ onBack }) => {
  const { params } = routeHelpersEmbeddedManageWalletCardsCard.useData();
  const queryCard = useQueryCard(params.cardId);

  return (
    <WSQueries
      queries={{ queryCard }}
      renderLoader={() => (
        <WSFlexBox.Center>
          <WalletCardSkeleton />
        </WSFlexBox.Center>
      )}
    >
      {({ queryCardData }) => (
        <WalletCardDetailsContent card={queryCardData} onBack={onBack} />
      )}
    </WSQueries>
  );
};

const WalletCardDetailsContent: React.FC<{
  card: cardApiSpec.Card;
  onBack: () => void;
}> = ({ card, onBack }) => {
  const cardType = card.isVirtualCard
    ? WalletCardType.Virtual
    : WalletCardType.Physical;

  const buttons = useActionButtons(card, {
    withReplaceCard: false,
    withSuccessModals: false,
    onCardClosed: onBack,
    onActionSuccess: action => sendCardUpdatedToParent(cardType, action)
  });

  return (
    <WSList gap="XL">
      <WSSectionToolbar title={WALLET_CARD_TITLES[cardType]} />
      <WSGrid gutter="XL">
        <WSGrid.Item span={{ s: "12", m: "6" }}>
          <WSList gap="XL">
            <WSFlexBox.Center>
              <EmbeddedWalletCardSlot
                cardType={cardType}
                card={card}
                onOrder={onBack}
              />
            </WSFlexBox.Center>
            <CardBillingInfo card={card} />
          </WSList>
        </WSGrid.Item>
        <WSGrid.Item span={{ s: "12", m: "6" }}>
          <WSList gap="XL">
            <CardBalance card={card} />
            <WSActions orientation="vertical" buttons={buttons} />
            <WSDivider />
            <WSActions
              orientation="vertical"
              buttons={[{ label: "Back", kind: "Secondary", onClick: onBack }]}
            />
          </WSList>
        </WSGrid.Item>
      </WSGrid>
    </WSList>
  );
};
